import { useEffect,useMemo,useRef,useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
// import {  Modal } from 'antd';
import { yupResolver } from "@hookform/resolvers/yup";
import { getAddressApi } from "api/services/employee";
import { checkBalanceLeave,getAllUsersData,getLeaveStatistics,postLeaveApi,statusChangeLeaveApi } from "api/services/leave";
import Attachment from "components/Attachments/attachmentListEdit";
import FilterSelect from "components/Form/filterSelect";
import useUploadHook from "components/uploadHook";
import { Controller,useFieldArray,useForm } from 'react-hook-form';
import { Link } from "react-router-dom";
import { customStyleSelect,formatDateHandler2,toTitleCase } from "utils/common";
import * as Yup from "yup";

import { BarElement,CategoryScale,Chart as ChartJS,Legend,LinearScale,Title,Tooltip } from 'chart.js';
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Button } from "components/Button";
import DateInput from "components/Form/dateInput";
import Image from "components/Image";
import EssFullWidthModal from "components/modelpopup/baseModal";
import { format } from "date-fns";
import { Bar } from 'react-chartjs-2';
import { useDropzone } from 'react-dropzone';
import { FaCalendarAlt,FaChartLine,FaCheck,FaCheckCircle,FaChevronDown,FaChevronUp,FaClock,FaTimes,FaTimesCircle,FaUser } from "react-icons/fa";
import { MdCheckCircleOutline,MdComment,MdOutlineError,MdPending,MdSchedule,MdWarning } from "react-icons/md";
import { useSelector } from "react-redux";
import { Bounce,toast } from 'react-toastify';
import { leaveStatusOptions } from "utils/constants";
import LeaveAttachment from "views/pages/Employees/leaves/leaveAttachment";

// Register ChartJS components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

// Keep chart options stable to avoid unnecessary chart re-inits
const LEAVE_STATISTICS_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  // Helper functions scoped to this options object via scriptable callbacks.
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Leave Statistics Overview",
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          let label = context.dataset.label || "";
          if (label) label += ": ";
          const y = context.parsed?.y;
          if (y === null || y === undefined) return label;
          return y !== 0 ? `${label}${y}` : `${label}No data`;
        },
      },
    },
    // Hide data labels for zero values (only applies if datalabels plugin is registered)
    datalabels: {
      // Center labels inside each stacked segment so they don't get clipped.
      anchor: "center",
      align: "center",
      clamp: true,
      clip: false,
      padding: 2,
      font: {
        weight: "400",
        size: 11,
      },
      // Plain, consistent label styling across all datasets.
      color: "#000000",
      formatter: (value) => {
        if (value === 0 || value === null || value === undefined) return "";
        const n = Number(value);
        if (!Number.isFinite(n) || n === 0) return "";
        // Keep labels compact but preserve decimals when present
        const abs = Math.abs(n);
        if (abs >= 100) return Math.round(n).toString();
        if (abs >= 10) return Number.isInteger(n) ? n.toString() : n.toFixed(1);
        return Number.isInteger(n) ? n.toString() : n.toFixed(2);
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: {
        display: true,
        text: "Number of Days",
      },
    },
    x: {
      title: {
        display: true,
        text: "Year",
      },
    },
  },
};

const EmployeeLeaveModelPopup = (props) => {
  const leaveApprovalSchema = Yup.object().shape({
    approval_status: Yup.object().required('Status is required'), 
    comment: Yup.string(), 

    // comments: Yup.string().test(
    //   'is-required-when-rejected',
    //   'Comments are required when the status is rejected',
    //   function (value) {
    //     const { approval_status } = this.parent; // Access the parent object
    //     return approval_status?.value !== 'rejected' || (value && value.trim().length > 0);
    //   }
    // ),
  
  });


  const [loading, setLoading] = useState(false);
  const [loadingLeaveBalance, setLoadingLeaveBalance] = useState(false);

  const [userOption, setUserOption] = useState([]);
  const [numberOfDays, setNumberOfDays] = useState("");
  const [leaveBalance, setLeaveBalance] = useState("");
  const [roleDelegationEnabled, setDelegationEnabled] = useState(false);
  const [roleDelegationOptions, setDelegationOptions] = useState([]);
  const [roleDelegationLoading, setDelegationLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);

  const [currentStatusStep, setCurrentStatusStep] = useState(0);
  const [statusSteps, setStatusSteps] = useState([]);
  const [isApprovalStatusCollapsed, setIsApprovalStatusCollapsed] = useState(false);
  // Two-step inline confirmation for the cancel-leave flow.
  // false → show the "Request Cancellation" prompt button.
  // true  → show the "Are you sure?" panel with reason + final confirm button.
  const [confirmingCancel, setConfirmingCancel] = useState(false);

  const [leaveAddress, setLeaveAddress] = useState([]);
  const [leaveAddressLoading, setLeaveAddressLoading] = useState(false);

  const [statisticsModal, setStatisticsModal] = useState(false);

  const [statisticsData, setStatisticsData] = useState(null);
  const [statisticsLoading, setStatisticsLoading] = useState(false);
  const statsInFlightRef = useRef(false);
  const statsLastUserIdRef = useRef(null);

  const leaveSchema = Yup.object().shape({
    leave_type: Yup.object().required('Leave type is required'), 
    start_date: Yup.date().required('Start date is required'), 
  
    end_date: Yup.date().required('End date is required').min(Yup.ref('start_date'), 'End date must be greater than start date'),
    comment: Yup.string().nullable().notRequired(), // Allows empty, null, or undefined,
    company_user: Yup.object().required('user is required'),
    role_delegation: Yup.object().nullable().notRequired(), // Allows empty, null, or undefined,
    // leave_address: Yup.mixed().when([], {
    //   is: () => (
    //     // leaveAddress.length > 0 && 
    //     user?.id == Yup.ref('company_user')?.value), // ✅ Check if leaveAddress array has items
    //   then: (schema) => schema.required("Leave address is required"),
    //   otherwise: (schema) => schema,
    // }),
    leave_address: Yup.mixed().when('company_user', {
      is: (company_user) => {
        console.log(company_user?.value,user?.id, "company_user")
        return  company_user?.value == user?.id},
      then: (schema) => schema.required("Leave address is required"),
      otherwise: (schema) => schema,
    }),
    attachments: Yup.array()
  
  });


  const {
    uploadLoading,
    handleFile
  } = useUploadHook()
  const {

    userData, userDataLoading,
  
   
} = useSelector((state) => state.common);
const {
  user,
  userLoading
} = useSelector((state) => state.user);
  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
    setError,
    reset  ,
    register,
    trigger
  } = useForm({
    resolver: yupResolver(leaveSchema), 
    defaultValues: {
      // company_user: userData.length===1 ? userData[0] : {}
    },
  });

  const {
    control: statusControl,
    handleSubmit: handleStatusSubmit,
    formState: { errors: statusError },
    setValue: setStatusValue,
    reset  : statusReset,
    setError: setStatusError
  } = useForm({
    resolver: yupResolver(leaveApprovalSchema), 
    defaultValues: {
      
    },
  });

  
  
  const [leaveBalanceSummary, setLeaveBalanceSummary] = useState(null);
  const [ canApplyLeave, setCanApplyLeave] = useState(false);

  // Derive the user's intent from the state of the request + their available
  // actions. This drives the modal title and the action-area copy so the
  // language matches what the viewer is actually here to do (review, cancel,
  // view, etc.) instead of the generic "Change Status".
  const viewerIntent = useMemo(() => {
    if (!props.selectedLeave) return "apply";
    if (statusOptions.length === 1 && statusOptions[0].value === "cancelled") {
      return "cancel_own";
    }
    if (statusOptions.some(o => o.value === "cancel_approved" || o.value === "cancel_rejected")) {
      return "review_cancellation";
    }
    if (statusOptions.some(o => o.value === "approved" || o.value === "rejected")) {
      return "review_request";
    }
    if (user?.id === props.selectedLeave?.company_user?.id) return "view_own";
    return "view";
  }, [statusOptions, user, props.selectedLeave]);

  const modalTitle = {
    apply: "Apply for Leave",
    cancel_own: "Your Leave Request",
    view_own: "Your Leave Request",
    review_request: "Review Leave Request",
    review_cancellation: "Review Cancellation Request",
    view: "Leave Request Details",
  }[viewerIntent];

  const decisionCopy = {
    review_request: {
      heading: "Your Decision",
      sub: "Approve or reject this leave request.",
    },
    review_cancellation: {
      heading: "Your Decision",
      sub: "Approve or reject this cancellation request.",
    },
  }[viewerIntent] || { heading: "Your Decision", sub: null };

  const calculateDays = (start, end) => {
    setLoading(true)
    setLoadingLeaveBalance(true)
    // Clear old values while waiting for API response
    setNumberOfDays("");
    setLeaveBalance("");
    setLeaveBalanceSummary(null);
    setCanApplyLeave(false);
    let data={};
    data["start_date"] = format(new Date(start), "yyyy-MM-dd");
    data["end_date"] = format(new Date(end), "yyyy-MM-dd");
    data['company_user'] = getValues("company_user")?.value
    data['leave_type'] = getValues("leave_type")?.value

    let number_of_days = 0;

    checkBalanceLeave(data).then(response=>{
      setLoadingLeaveBalance(false)
      setLoading(false)
      setLeaveBalanceSummary(response.data)
      if (response.data && response.data.no_of_days) {
 
          number_of_days =  response.data.no_of_days;
         setNumberOfDays(number_of_days)
         setLeaveBalance(response.data.leave_balance)
         setCanApplyLeave(response.data.can_apply_leave)
      } else {
        number_of_days =  0;
        setNumberOfDays(number_of_days)
      }

      
    }).catch(e=> {
      console.log(e, "eee")
      setLoadingLeaveBalance(false)
      setLoading(false)
    })

   
   
  };





  const fetchAddressList = ()=> {
    setLeaveAddressLoading(true)
    getAddressApi({company_user: company_user?.value}).then(response=>{
      setLeaveAddress(response.data.results.map(item=>{
        return{
          label: item.name,
          value: item.id,
          ...item
        }
      }))
      setLeaveAddressLoading(false)
      trigger("leave_address")
    }).catch(e=>{
      setLeaveAddressLoading(false)
    })
  }

  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormProvider)
    name: "attachments", // unique name for your Field Array
    
  });


  const createApprovalSteps = () => {
    let generated_steps = []
    let current_step = props?.selectedLeave?.approval_level
    let existing_steps = props?.selectedLeave?.leave_approval
    
    if(props?.selectedLeave?.approval_status == "cancelled"){
      generated_steps.push({
        title: 'Request',
        subTitle: "Cancelled",
        description:<span className="text-wrap lh-1 text-dark" style={{fontSize:11, lineHeight: "1.5"}} >{`Requested on ${formatDateHandler2(props.selectedLeave?.created_at)} | ${props?.selectedLeave?.request_created_by?.first_name} ${props?.selectedLeave?.request_created_by?.last_name} ${props?.selectedLeave?.comment ? " | Comment : " + props?.selectedLeave?.comment : ""}`}</span>,
        icon: <FaTimesCircle  color="red" size={35} />
      })

    }else{
      generated_steps.push({
        title: 'Request',
        subTitle: "Created",
        description:<span className="text-wrap lh-1 text-dark" style={{fontSize:11, lineHeight: "1.5"}} >{`Requested on ${formatDateHandler2(props.selectedLeave?.created_at)} | ${props?.selectedLeave?.request_created_by?.first_name} ${props?.selectedLeave?.request_created_by?.last_name} ${props?.selectedLeave?.comment ? " | Comment : " + props?.selectedLeave?.comment : ''}`}</span>,
        icon: <FaCheckCircle  color="green" size={35} />
      })
    }
    existing_steps.forEach(item => {
      let stepDetails = {
        title: item?.approval_type === "request" ? 'Approval' : 'Cancellation',
        subTitle: toTitleCase(item?.status)
      };
      
      // Set icon and description based on status in one switch
      switch(item?.status) {
        case "pending":
          stepDetails.icon = <MdPending size={35} />;
          stepDetails.description = <span className="text-wrap lh-1 text-dark" style={{fontSize:11, lineHeight: "1.5"}}>
            {`Pending approval |  ${item?.approver?.first_name || ""} ${item?.approver?.last_name || ""} ${item?.comment ? "| Comment: " + item?.comment : ''}`}
          </span>;
          break;
          
        case "rejected":
          stepDetails.icon = <FaTimesCircle color="red" size={35} />;
          stepDetails.description = <span className="text-wrap lh-1 text-dark" style={{fontSize:11, lineHeight: "1.5"}}>
            {`Rejected on ${formatDateHandler2(item?.approved_on)} ${item?.comment ? "| Comment: " + item?.comment : ''}`}
          </span>;
          break;
          
        case "escalated":
          stepDetails.title = "Escalated"
          stepDetails.subTitle = ""
          stepDetails.icon = <i className="fa fa-exclamation-triangle" style={{ color: "#FFC107", fontSize: "35px" }} />;
          stepDetails.description = <span className="text-wrap lh-1 text-dark" style={{fontSize:11, lineHeight: "1.5"}}>
            {`Escalated on ${formatDateHandler2(item?.approved_on)} | ${item?.approver?.first_name || ""} ${item?.approver?.last_name || ""} ${item?.comment ? "| Comment: " + item?.comment : ''}`}
          </span>;
          break;
          
        default: // approved or any other status
          stepDetails.icon = <FaCheckCircle color="green" size={35} />;
          stepDetails.description = <span className="text-wrap lh-1 text-dark" style={{fontSize:11, lineHeight: "1.5"}}>
            {`${item?.status=="pending"? item.approver?.first_name+" "+ item.approver?.last_name : toTitleCase(item.status)+" on "+ formatDateHandler2(item?.approved_on) +" | "+item.approver?.first_name+" "+ item.approver?.last_name}  ${item?.comment ? "| Comment : " + item?.comment : ''}`}
            {/* {`${toTitleCase(item.status)} on ${formatDateHandler2(item?.approved_on)} ${item?.comment ? "| Comment: " + item?.comment : ''}`} */}
          </span>;
      }
      
      generated_steps.push(stepDetails);
    });
    // existing_steps.forEach(item=> {
    //   generated_steps.push({
    //     title: 'Approval',
    //     subTitle: toTitleCase(item?.status),
    //     description:<span className="text-wrap lh-1" style={{fontSize:9}} >{`${item?.status=="pending"? item.approver?.first_name+" "+ item.approver?.last_name : toTitleCase(item.status)+" on "+ formatDateHandler2(item?.approved_on) +" by "+item.approver?.first_name+" "+ item.approver?.last_name}  ${item?.comment ? "| Comment : " + item?.comment : ''}`}</span>,
    //     icon:item?.status=="pending" ?<MdPending   size={35} /> : item?.status=="rejected" ? <FaTimesCircle  color="red" size={35} /> : <FaCheckCircle  color="green" size={35} />
    //   })
    // })
    setCurrentStatusStep(current_step)
    setStatusSteps(generated_steps)
    // let steps = [
    //   {
    //     title: 'Requested',
    //     description:'Requested on 12-12-2025',
    //     icon: <FaCheckCircle  color="green" size={35} />
    //   },
    //   {
    //     title: 'Approval',
    //     subTitle: 'Pending',
    //     description:'Manzeer MM',
    //     icon: <MdPending   size={35} />
    //   },
    //   {
    //     title: 'Approval',
    //     subTitle: 'Pending',
    //     description:'Arun A',
    //     icon: <MdPending   size={35} />

    //   },
    // ]
  }
  

  useEffect(()=>{

    if(props.selectedLeave){
      console.log(user,props.selectedLeave.company_user, "UUUUU")
      if(user.id == props.selectedLeave.company_user?.id
        //  && props.selectedLeave?.approval_status=="pending"
        ){
        setStatusOptions(leaveStatusOptions.filter(item=> item.value== "cancelled"))
      }

      if(user.id == props.selectedLeave.current_approver?.id && props.selectedLeave?.approval_status=="pending"){
        setStatusOptions(leaveStatusOptions.filter(item=> item.value != "cancelled" && item.value != "cancel_pending" && item.value != "cancel_rejected" && item.value != "cancel_approved"))
      }

      if(props.selectedLeave?.approval_status=="cancel_pending" && user.id == props.selectedLeave.current_approver?.id){
        setStatusOptions(leaveStatusOptions.filter(item=> item.value== "cancel_rejected" || item.value== "cancel_approved"))
      }

      // HR / leave-request approver can override the workflow on another
      // employee's leave: approve a pending request, or cancel an active leave,
      // regardless of whose turn it is. The BE accepts both and still enforces
      // the salary cut-off on cancel. Options are appended so we don't drop the
      // approve/reject HR may already have as the legitimate current approver.
      const isLeaveApprover =
        user?.is_leave_request_approver === true ||
        user?.is_leave_request_approver === "True" ||
        user?.is_leave_request_approver === "true";
      const leaveStatus = props.selectedLeave?.approval_status;
      if (isLeaveApprover && user.id != props.selectedLeave.company_user?.id) {
        const ensureOption = (value) =>
          setStatusOptions((prev) => {
            if (prev.some((o) => o.value === value)) return prev;
            const opt = leaveStatusOptions.find((o) => o.value === value);
            return opt ? [...prev, opt] : prev;
          });
        if (["pending", "escalated"].includes(leaveStatus)) ensureOption("approved");
        if (["pending", "escalated", "approved"].includes(leaveStatus)) ensureOption("cancelled");
      }

      createApprovalSteps()
    }else{
      setStatusOptions([])
    }
  }, [props.selectedLeave])

  // When the user's only available action is "cancel" (i.e. cancelling their
  // own pending request), pre-select that status so the final confirm click
  // submits the form directly without requiring a status pill toggle.
  useEffect(() => {
    if (statusOptions.length === 1 && statusOptions[0].value === "cancelled") {
      setStatusValue("approval_status", { label: "Cancelled", value: "cancelled" });
    }
  }, [statusOptions, setStatusValue]);

  // Reset the two-step cancel confirmation whenever the modal closes or the
  // selected leave changes, so the user starts at step 1 next time.
  useEffect(() => {
    if (!props.leaveModal) setConfirmingCancel(false);
  }, [props.leaveModal, props.selectedLeave]);

  useEffect(()=>{
    setDelegationLoading(true)
    getAllUsersData().then(response=>{
      let all_ = response.data.map(item=>{
        return{
          label: `${item.first_name} ${item.last_name}`,
          value: item.id
        }
      })
      setDelegationOptions(all_)
      setDelegationLoading(false)
    })

    
  },[])


  useEffect(()=>{
    if(props?.selectedLeave?.id){
      console.log(props?.selectedLeave, "HHHHH")
      // setStatusValue("comment", props.selectedLeave?.comment||"")
      // let approvalStatus = leaveStatusOptions.find(item=> item.value == props.selectedLeave.approval_status)
      // console.log(approvalStatus, leaveStatusOptions,props.selectedLeave.approval_status, "JJJJ")
      // setStatusValue("approval_status", approvalStatus)

    }else{
      // reset()
      resetData()

      statusReset()

      let selectedUserOption = userOption.find(item=> item.value == user?.id)
      if(selectedUserOption){
        console.log(selectedUserOption, "SELECTEDDDDDDDDD")
        setValue("company_user", selectedUserOption)
      }

    }
  }, [props.selectedLeave, props.leaveModal, userOption])

  const resetData = () => {
    reset({
      company_user: null,
      leave_type: null,
      start_date: null,
      end_date: null,
      comment: "",
      attachments: [],
      role_delegation: null,
      leave_address: null,

    })
  }
  
  useEffect(()=>{
    let access_scope =  "all"; //props.user.role.access_scope;
    if (userData && props.user) {
      let users = [];
  
      if (access_scope === "all" || access_scope === "hierarchy") {
          users = userData.map(item => ({
              label: `${item.first_name} ${item.last_name} | ${item.emp_no}`,
              value: item.id,

          }));
      } else if (access_scope === "self") {
          users = userData
              .filter(item => item.id === props.user.id) // Restrict to logged-in user
              .map(item => ({
                  label: `${item.first_name} ${item.last_name} | ${item.emp_no}`,
                  value: item.id
              }));
      }
     
      setUserOption(users);
      
  }
  
   
    // if(userData){
    //   let users = userData.map(item=> {
    //     return{
    //         label: `${item.first_name} ${item.last_name}`,
    //         value: item.id
    //     }
    // })
    //   setUserOption(users)
    // }
  
  
  },[userData])

  

  useEffect(()=>{
    if(userOption.length){
      if(userOption.length===1){
        console.log("&&&&&&&&&&&&&&&&&",userOption[0])
        setValue("company_user", userOption[0])
      }
    }
  },[userOption, props.selectedLeave, props.leaveModal])

  
  // const fileUploadHandler = async(e) => {
  //   console.log(e.target.files, "EEEE")
  //   let attachments = []
  //   const urls = await handleFile(e);
  //   if(Array.isArray(urls)){
  //      attachments = urls.map(item=>{return{url: item}})
  //   }else{
  //     attachments.push({
  //       url:urls
  //     })
  //   }
  //   console.log(fields, "LLLL")

  //   setValue("attachments", [...fields,...attachments])
  //  }

  const fileUploadHandler = async(acceptedFiles , rejectedFiles , e) => {
    console.log(e.target.files, "EEEE")
    let attachments = []
    const urls = await handleFile(e);
    if(Array.isArray(urls)){
       attachments = urls.map(item=>{return{url: item}})
    }else{
      attachments.push({
        url:urls
      })
    }
    console.log(fields, "LLLL")

    setValue("attachments", [...fields,...attachments])
   }


  const { getRootProps, getInputProps } = useDropzone({
    onDrop: fileUploadHandler,

    accept: 'image/*', // Accept image, PDF, DOCX
    // disabled: user.id == selectedUserAsset?.current_approver?.id
  });



   const onStatusChange = (data) => {
    setLoading(true)

    console.log(data, "LLLLL")
    
    data['approval_status'] = data?.approval_status?.value
    statusChangeLeaveApi(data, props.selectedLeave?.id).then(response=>{
      setLoading(false)

      toast.success('Leave status updated!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        props.setLeaveModal(false)
        props.setSelectedLeave("")
        // reset()
        resetData()
        statusReset()
        props.fetchLeaveList()

      console.log(response, "REEEEEE")
    }).catch(e=> {
      console.log(e, "eee")
      try{
        console.log(e.response.data, "EEEEE")
        // let response = e.response?.data?.error || "Error updating leave status!"
        setLoading(false)
          // toast.error(response, {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          //   closeOnClick: false,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "light",
          //   transition: Bounce,
          //   });

      if(e.response.data){
        Object.entries(e.response.data).forEach(([k, v]) => {
          console.log(typeof v,k, "EEEEE")
          setStatusError(k,
            {
              type: 'manual',
              message: v.join(", ")
            }
             )
        })
      }
      }catch(err){
        console.log(err, "LLLLLLL")
        let response = e.response?.data?.error || "Error updating leave status!"
        setLoading(false)
          toast.error(response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        
      }



      
    })


   }
   const  onSubmit = (formData) =>{
    if(!canApplyLeave){
    
      toast.error("You are not authorized to apply leave!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        })
        return
    }

    
    // Check if user is a leave request approver
    const isLeaveRequestApprover = user?.is_leave_request_approver === true || 
                                   user?.is_leave_request_approver === "True" || 
                                   user?.is_leave_request_approver === "true";

    // If not an approver, check probation restrictions for probation-restricted leave types
    if (!isLeaveRequestApprover) {
      const probationRestrictedCodes = ["SYSANNUAL", "PATERNITY LEAVE", "SYSMAT"];
      const selectedLeaveType = formData?.leave_type;
      
      // Get the leave type code - check from selectedLeaveType first, then from props.leaveTypes
      let selectedLeaveCode = selectedLeaveType?.code?.toUpperCase();
      if (!selectedLeaveCode && selectedLeaveType?.value) {
        // If code is not in selectedLeaveType, find it from props.leaveTypes
        const fullLeaveType = props.leaveTypes.find(lt => lt.value === selectedLeaveType.value);
        selectedLeaveCode = fullLeaveType?.code?.toUpperCase();
      }
      
      // Check if selected leave type is a probation-restricted leave
      const isProbationRestrictedLeave = probationRestrictedCodes.some(restrictedCode => {
        const codeMatches = selectedLeaveCode === restrictedCode.toUpperCase();
        const labelMatches = selectedLeaveType?.label?.toUpperCase().includes(restrictedCode.toUpperCase()) ||
          (restrictedCode === "SYSANNUAL" && selectedLeaveType?.label?.toUpperCase().includes("ANNUAL LEAVE")) ||
          (restrictedCode === "PATERNITY LEAVE" && selectedLeaveType?.label?.toUpperCase().includes("PATERNITY")) ||
          (restrictedCode === "SYSMAT" && selectedLeaveType?.label?.toUpperCase().includes("MATERNITY"));
        return codeMatches || labelMatches;
      });

      if (isProbationRestrictedLeave) {
        // Get the selected user from userData
        const selectedUser = userData.find(item => item.id === formData?.company_user?.value);
        
        if (selectedUser?.probation_ends_on_date) {
          const probationEndDate = new Date(selectedUser.probation_ends_on_date);
          const startDate = new Date(formData.start_date);
          
          // Check if start date falls within probation period (before probation ends)
          if (startDate < probationEndDate) {
            toast.error("You cannot apply this leave type during the probation period. Probation ends on " + formatDateHandler2(selectedUser.probation_ends_on_date), {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Bounce,
            });
            return;
          }
        }
      }
    }

    let data = {
      ...formData
    }
    console.log(data, "LLLLL")
    setLoading(true)
    data['leave_type'] = data?.leave_type?.value
    data['company_user'] = data?.company_user?.value
    data['role_delegation'] = data?.role_delegation?.value
    data['leave_address'] = data?.leave_address?.value

    let attachments_data = data['attachments']?.map(item=>{
      return item.url
    })
    data['attachments'] = attachments_data

    // reset()
    // data['department'] = data?.department?.value
    // data['status'] = data?.status?.value
    if(data.start_date){
      data['start_date'] = format(new Date(data.start_date), "yyyy-MM-dd")
    }
    if(data.end_date){
      data['end_date'] = format(new Date(data.end_date), "yyyy-MM-dd")
    }
    
    
    console.log(leaveBalance, "=---leaveBalance ", numberOfDays)

     //(leaveBalance > numberOfDays) validate if balance leave is available to apply
      postLeaveApi(data).then(response=>{
        setLoading(false)
  
        toast.success('Leave applied!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          props.setLeaveModal(false);
        
          props.fetchLeaveList();
          // reset()
          resetData()
          statusReset()

        console.log(response, "REEEEEE")
      }).catch(e=> {
        console.log(e, "eee")
        setLoading(false)
        try{
          console.log(e.response.data, "EEEEE")
        if(e.response.data){
          Object.entries(e.response.data).forEach(([k, v]) => {
            console.log(typeof v, "EEEEE")
            setError(k,
              {
                type: 'manual',
                message: v.join(", ")
              }
               )
          })
        }
        }catch(err){
          let message = e.response?.data?.error || 'Failed to apply leave!'
          toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }
  
        
      })

    
    

   
  }

  const start = watch("start_date");
  const end = watch("end_date");
  const company_user = watch("company_user")
  const leave_type = watch("leave_type")

  // Native `<input type="date" />` values come as `YYYY-MM-DD` strings.
  // DateInput expects min/max as Date objects, so derive those here.
  const startDateObj = useMemo(() => (start ? new Date(start) : null), [start]);
  // const endDateObj = useMemo(() => (end ? new Date(end) : null), [end]);

  useEffect(() => {
    if (start && end && company_user?.value && leave_type?.value) {
      calculateDays(start, end);
    }
  }, [start, end, company_user?.value, leave_type?.value])
  useEffect(()=>{
    if(props.leaveModal){
      fetchAddressList()
    }
  },[props.leaveModal, company_user?.value])


  const leave_address = watch("leave_address")

  const filteredLeaveType = useMemo(() => {
    let selectedUser = userData.find(item => item.id === company_user?.value);
    let filteredTypes = [...props.leaveTypes];
    
    // Maternity/paternity are gated on gender only. Marital status is not a
    // condition — divorced/widowed/single employees remain eligible.
    if (selectedUser?.gender === "female") {
      // For female users, filter out paternity leave
      filteredTypes = filteredTypes.filter(item => item.label !== "Paternity Leave");
    } else if (selectedUser?.gender === "male") {
      // For male users, filter out maternity leave
      filteredTypes = filteredTypes.filter(item => item.label !== "Maternity Leave");
    }
    
    // Show all leaves to everyone - probation restriction is now handled in validation
    // instead of hiding leaves
    
    return filteredTypes;
  }, [props.leaveTypes, company_user, userData]);




  const leaveType = watch("leave_type")
  const LeaveAddressSelected = ({ address }) => {
    const rows = [
      { label: "Name", value: address?.name },
      {
        label: "Address",
        value: [address?.address_1, address?.address_2].filter(Boolean).join(", "),
      },
      { label: "City", value: address?.city },
      { label: "Country", value: address?.country?.name },
      { label: "Emergency Contact", value: address?.emergency_contact_name },
      { label: "Emergency Number", value: address?.emergency_contact_number },
    ];
    return (
      <div
        className="card border-0 shadow-sm"
        style={{ borderRadius: 12, padding: 18, background: "#ffffff" }}
      >
        <div className="d-flex align-items-center mb-3">
          <div
            style={{
              width: 32, height: 32, borderRadius: 10,
              background: "#fef2f2", color: "#dc2626",
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              marginRight: 10,
            }}
          >
            <i className="la la-map-marker-alt" style={{ fontSize: 16 }} aria-hidden="true" />
          </div>
          <div style={{ fontWeight: 700, fontSize: 14, color: "#111827" }}>
            Leave Address
          </div>
        </div>
        <div className="row g-3">
          {rows.map(({ label, value }) => (
            <div className="col-md-6" key={label}>
              <div
                style={{
                  fontSize: 11.5,
                  fontWeight: 600,
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                  color: "#9ca3af",
                  marginBottom: 4,
                }}
              >
                {label}
              </div>
              <div style={{ fontSize: 13.5, color: "#1f2937", fontWeight: 500 }}>
                {value || <span style={{ color: "#9ca3af", fontWeight: 400 }}>—</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const fetchLeaveStatistics = () => {
    // if (!props.selectedLeave?.company_user?.id) return;
    const userId = props.selectedLeave
      ? props.selectedLeave.company_user.id
      : company_user?.value;

    if (!userId) return;
    // prevent duplicate calls during quick re-renders / StrictMode dev behavior
    if (statsInFlightRef.current && statsLastUserIdRef.current === userId) return;
    statsInFlightRef.current = true;
    statsLastUserIdRef.current = userId;

    setStatisticsLoading(true);
    let params = {
     
    }
    params['user'] = userId;
    getLeaveStatistics(params)
      .then(response => {
        setStatisticsData(response.data);
        setStatisticsLoading(false);
      })
      .catch(error => {
        console.error("Error fetching leave statistics:", error);
        setStatisticsLoading(false);
        toast.error("Failed to load leave statistics", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      })
      .finally(() => {
        statsInFlightRef.current = false;
      });
  };


  useEffect(() => {
    if (!statisticsModal) return;
    fetchLeaveStatistics();
    // Only refetch when the user changes (not on other form input changes)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsModal, props.selectedLeave?.company_user?.id, company_user?.value]);


  const StatisticComponent = () => {
    if(statisticsModal){

    
    return (
      <div className="col-md-12 d-flex flex-column align-items-end">
        <Button
          // label="Close"
          icon="fa fa-close"
          className="btn btn-primary btn-sm"
          onClick={() => setStatisticsModal(false)}
        />
              
              <div  className="w-100">
              {statisticsLoading ? (
                <div className="text-center py-5">
                  <i className="fas fa-spinner fa-spin fa-2x"></i>
                  <p className="mt-2">Loading statistics...</p>
                </div>
              ) : statisticsData ? (
                <div className="chart-container" style={{ position: 'relative', height: '400px' }}>
                  <Bar
                    data={statisticsData?.graph_data}
                    options={LEAVE_STATISTICS_CHART_OPTIONS}
                  />
                </div>
              ) : (
                <div className="alert alert-info">
                  No statistics data available for {props.selectedLeave?.company_user?.first_name} {props.selectedLeave?.company_user?.last_name}.
                </div>
              )}
              </div>
              
              
            </div>
    )
  }
  return (<></>)
  }
  return (
    <>

        <EssFullWidthModal
        mask={false}
              title={modalTitle}
              // style={{ top: 100 }}
              open={props.leaveModal}
              width={"40%"}
              footer={[]}     
              onCancel={() => {
                // reset()
                resetData()
                statusReset()
                setDelegationEnabled(false);
                setStatisticsModal(false);
                
                props?.setSelectedLeave("")
                props.setLeaveModal(false)}}
                className="full-width-modal"


            >
              
          <div className="modal-content">
           
            <div className="modal-body" style={{ padding: "24px" }}>
              {
                props?.selectedLeave?.id ? (
                <form  onSubmit={handleStatusSubmit(onStatusChange)}>

                  {/* Contextual intro banner — single line that tells the
                      viewer what they're here to do, in their own language.
                      Skipped for the cancel-own flow (the bottom cancel card
                      already has its own explanatory copy). */}
                  {viewerIntent !== "view_own" && viewerIntent !== "view" && viewerIntent !== "cancel_own" && (
                    <div
                      className="d-flex align-items-center mb-3"
                      style={{
                        gap: 12,
                        padding: "12px 16px",
                        borderRadius: 10,
                        background:
                          viewerIntent === "cancel_own"
                            ? "#fef3c7"
                            : viewerIntent === "review_cancellation"
                            ? "#fef2f2"
                            : "#eff6ff",
                        color:
                          viewerIntent === "cancel_own"
                            ? "#92400e"
                            : viewerIntent === "review_cancellation"
                            ? "#991b1b"
                            : "#1e40af",
                        fontSize: 13.5,
                      }}
                    >
                      <i
                        className={
                          viewerIntent === "cancel_own"
                            ? "la la-info-circle"
                            : viewerIntent === "review_cancellation"
                            ? "la la-exclamation-triangle"
                            : "la la-clipboard-check"
                        }
                        style={{ fontSize: 18 }}
                        aria-hidden="true"
                      />
                      <div style={{ lineHeight: 1.4 }}>
                        {viewerIntent === "review_request" && (
                          <>
                            <strong>Awaiting your approval.</strong>{" "}
                            Review the details below and approve or reject.
                          </>
                        )}
                        {viewerIntent === "review_cancellation" && (
                          <>
                            <strong>Cancellation requested.</strong>{" "}
                            The employee wants to cancel an already-approved leave.
                          </>
                        )}
                        {viewerIntent === "cancel_own" && (
                          <>
                            <strong>This is your leave request.</strong>{" "}
                            Use the action below if you need to cancel it.
                          </>
                        )}
                      </div>
                    </div>
                  )}


                  {/* Approval Status Timeline - New Modern Design */}
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className="card shadow-sm border-0" style={{ borderRadius: "16px", padding: "24px", background: "#ffffff" }}>
                        <div 
                          className="d-flex align-items-center justify-content-between mb-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsApprovalStatusCollapsed(!isApprovalStatusCollapsed)}
                        >
                          <div className="d-flex align-items-center">
                            <div style={{ 
                              width: "40px", 
                              height: "40px", 
                              borderRadius: "12px", 
                              background: "linear-gradient(135deg, #d3001a 0%, #ff4757 50%, #ff6348 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "12px"
                            }}>
                              <FaClock style={{ color: "#ffffff", fontSize: "20px" }} />
                            </div>
                            <div>
                              <label className="mb-0" style={{ fontWeight: "700", fontSize: "16px", color: "#1f2937" }}>
                                Approval Status
                              </label>
                              <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                                {statusSteps.length} {statusSteps.length === 1 ? 'step' : 'steps'} in workflow
                              </div>
                            </div>
                          </div>
                          <div style={{ 
                            width: "32px", 
                            height: "32px", 
                            borderRadius: "8px", 
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f3f4f6",
                            transition: "all 0.2s ease"
                          }}>
                            {isApprovalStatusCollapsed ? (
                              <FaChevronDown style={{ fontSize: "14px", color: "#6b7280" }} />
                            ) : (
                              <FaChevronUp style={{ fontSize: "14px", color: "#6b7280" }} />
                            )}
                          </div>
                        </div>
                        
                        {!isApprovalStatusCollapsed && (
                        <div 
                          style={{ 
                            overflowX: "auto", 
                            overflowY: "visible",
                            paddingBottom: "10px",
                            WebkitOverflowScrolling: "touch",
                            scrollbarWidth: "thin",
                            scrollbarColor: "#cbd5e1 #f3f4f6"
                          }}
                          className="approval-status-container"
                        >
                          <style>{`
                            @media (max-width: 768px) {
                              .approval-status-container {
                                overflow-x: visible !important;
                              }
                              .approval-status-wrapper {
                                flex-direction: column !important;
                                width: 100% !important;
                                gap: 20px !important;
                              }
                              .approval-status-card {
                                width: 100% !important;
                                max-width: 100% !important;
                                height: auto !important;
                                min-height: 140px !important;
                              }
                              .timeline-connector {
                                display: none !important;
                              }
                            }
                          `}</style>
                          <div style={{ minWidth: "max-content", padding: "8px 0" }}>
                            <div className="approval-status-wrapper" style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                              {statusSteps.map((step, index) => {
                                const isCompleted = index < currentStatusStep;
                                const isCurrent = index === currentStatusStep;
                                const isPending = index > currentStatusStep;
                                
                                // Determine status color and icon based on step data
                                let statusColor = "#6b7280";
                                let statusBg = "#f3f4f6";
                                let statusIcon = null;
                                
                                if (step.subTitle?.toLowerCase() === "cancelled" || step.subTitle?.toLowerCase() === "rejected") {
                                  statusColor = "#ef4444";
                                  statusBg = "#fef2f2";
                                  statusIcon = <FaTimesCircle style={{ fontSize: "22px", color: statusColor }} />;
                                } else if (step.subTitle?.toLowerCase() === "created" || step.subTitle?.toLowerCase() === "approved") {
                                  statusColor = "#10b981";
                                  statusBg = "#f0fdf4";
                                  statusIcon = <MdCheckCircleOutline style={{ fontSize: "24px", color: statusColor }} />;
                                } else if (step.subTitle?.toLowerCase() === "pending") {
                                  statusColor = "#3b82f6";
                                  statusBg = "#eff6ff";
                                  statusIcon = <MdSchedule style={{ fontSize: "24px", color: statusColor }} />;
                                } else if (step.subTitle?.toLowerCase() === "escalated") {
                                  statusColor = "#f59e0b";
                                  statusBg = "#fffbeb";
                                  statusIcon = <MdWarning style={{ fontSize: "24px", color: statusColor }} />;
                                } else {
                                  statusIcon = step.icon || <FaClock style={{ fontSize: "22px", color: statusColor }} />;
                                }
                                
                                // Parse description to show on multiple lines with icons
                                let descriptionText = '';
                                if (typeof step.description === 'string') {
                                  descriptionText = step.description;
                                } else if (step.description?.props?.children) {
                                  const children = step.description.props.children;
                                  if (Array.isArray(children)) {
                                    descriptionText = children.map(c => typeof c === 'string' ? c : '').join('');
                                  } else if (typeof children === 'string') {
                                    descriptionText = children;
                                  } else {
                                    // Try to extract from template literal
                                    descriptionText = String(children);
                                  }
                                }
                                
                                // Function to parse and format description parts with icons
                                const parseDescriptionPart = (part) => {
                                  const trimmedPart = part.trim();
                                  if (!trimmedPart) return null;
                                  
                                  // Check for common patterns and add icons
                                  if (trimmedPart.toLowerCase().includes('requested on')) {
                                    const date = trimmedPart.replace(/requested on/gi, '').trim();
                                    return { icon: <FaCalendarAlt style={{ fontSize: "12px", color: "#6b7280" }} />, text: date };
                                  } else if (trimmedPart.toLowerCase().includes('rejected on')) {
                                    const date = trimmedPart.replace(/rejected on/gi, '').trim();
                                    return { icon: <FaTimes style={{ fontSize: "12px", color: "#ef4444" }} />, text: date };
                                  } else if (trimmedPart.toLowerCase().includes('approved on') || trimmedPart.toLowerCase().includes('approved')) {
                                    const text = trimmedPart.replace(/approved on/gi, '').replace(/approved/gi, '').trim();
                                    return { icon: <FaCheck style={{ fontSize: "12px", color: "#10b981" }} />, text: text || 'Approved' };
                                  } else if (trimmedPart.toLowerCase().includes('escalated on')) {
                                    const date = trimmedPart.replace(/escalated on/gi, '').trim();
                                    return { icon: <MdWarning style={{ fontSize: "12px", color: "#f59e0b" }} />, text: date };
                                  } else if (trimmedPart.toLowerCase().includes('pending approval')) {
                                    const approver = trimmedPart.replace(/pending approval/gi, '').trim();
                                    return { icon: <MdSchedule style={{ fontSize: "12px", color: "#3b82f6" }} />, text: approver || 'Pending' };
                                  } else if (trimmedPart.toLowerCase().includes('comment')) {
                                    const comment = trimmedPart.replace(/comment\s*:?\s*/gi, '').trim();
                                    return { icon: <MdComment style={{ fontSize: "12px", color: "#6b7280" }} />, text: comment };
                                  } else if (trimmedPart.match(/^[A-Z][a-z]+\s+[A-Z][a-z]+(\s+[A-Z][a-z]+)?$/)) {
                                    // Likely a person's name (First Last or First Middle Last)
                                    return { icon: <FaUser style={{ fontSize: "12px", color: "#6b7280" }} />, text: trimmedPart };
                                  }
                                  
                                  // Default: just return the text
                                  return { icon: null, text: trimmedPart };
                                };
                                
                                const descriptionParts = descriptionText 
                                  ? descriptionText.split('|').map(parseDescriptionPart).filter(part => part !== null)
                                  : [];
                                
                                return (
                                  <div 
                                    key={index}
                                    className="approval-status-card"
                                    style={{
                                      width: "240px",
                                      height: "140px",
                                      flex: "0 0 auto"
                                    }}
                                  >
                                    <div style={{ display: "flex", gap: "12px", alignItems: "flex-start", height: "100%" }}>
                                      {/* Timeline Line & Icon */}
                                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", position: "relative", height: "100%" }}>
                                        <div style={{
                                          width: "48px",
                                          height: "48px",
                                          borderRadius: "12px",
                                          background: statusBg,
                                          border: `2px solid ${statusColor}`,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          flexShrink: 0,
                                          boxShadow: isCurrent ? `0 0 0 4px ${statusColor}20` : "none",
                                          transition: "all 0.3s ease",
                                          position: "relative"
                                        }}>
                                          <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: "100%"
                                          }}>
                                            {statusIcon}
                                          </div>
                                        </div>
                                        {index < statusSteps.length - 1 && (
                                          <div 
                                            className="timeline-connector"
                                            style={{
                                              width: "2px",
                                              flex: 1,
                                              background: index < currentStatusStep ? statusColor : "#e5e7eb",
                                              marginTop: "8px",
                                              minHeight: "calc(140px - 48px - 8px)",
                                              transition: "background 0.3s ease"
                                            }} 
                                          />
                                        )}
                                      </div>
                                      
                                      {/* Content Card */}
                                      <div style={{ flex: 1, paddingTop: "4px", width: "100%", height: "100%" }}>
                                        <div style={{
                                          background: "#f9fafb",
                                          borderRadius: "10px",
                                          padding: "12px",
                                          border: isCurrent ? `1px solid ${statusColor}` : "1px solid #e5e7eb",
                                          transition: "all 0.3s ease",
                                          height: "100%",
                                          display: "flex",
                                          flexDirection: "column"
                                        }}>
                                          <div style={{ 
                                            fontWeight: "600", 
                                            fontSize: "13px", 
                                            color: "#1f2937",
                                            marginBottom: "6px"
                                          }}>
                                            {step.title}
                                          </div>
                                          {step.subTitle && (
                                            <div style={{ 
                                              fontSize: "11px", 
                                              color: statusColor,
                                              fontWeight: "600",
                                              marginBottom: "8px",
                                              textTransform: "uppercase",
                                              letterSpacing: "0.5px"
                                            }}>
                                              {step.subTitle}
                                            </div>
                                          )}
                                          <div style={{ 
                                            fontSize: "11px", 
                                            color: "#6b7280",
                                            lineHeight: "1.6",
                                            flex: 1,
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "6px"
                                          }}>
                                            {descriptionParts.length > 0 ? (
                                              descriptionParts.map((part, partIndex) => (
                                                <div 
                                                  key={partIndex} 
                                                  style={{ 
                                                    wordWrap: "break-word",
                                                    whiteSpace: "normal",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px"
                                                  }}
                                                >
                                                  {part.icon && (
                                                    <span style={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
                                                      {part.icon}
                                                    </span>
                                                  )}
                                                  <span style={{ flex: 1, lineHeight: "1.4" }}>{part.text}</span>
                                                </div>
                                              ))
                                            ) : (
                                              <div style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
                                                {step.description}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                        )}
                      </div>
                    </div>
                  </div>

              {/* Combined Leave Information Card */}
              {(() => {
                const status = (props.selectedLeave?.approval_status || "").toLowerCase();
                const statusPalette = {
                  pending: { bg: "#fef3c7", text: "#92400e", dot: "#f59e0b" },
                  cancel_pending: { bg: "#fef3c7", text: "#92400e", dot: "#f59e0b" },
                  approved: { bg: "#dcfce7", text: "#166534", dot: "#16a34a" },
                  cancel_approved: { bg: "#dcfce7", text: "#166534", dot: "#16a34a" },
                  rejected: { bg: "#fee2e2", text: "#991b1b", dot: "#dc2626" },
                  cancel_rejected: { bg: "#fee2e2", text: "#991b1b", dot: "#dc2626" },
                  cancelled: { bg: "#f3f4f6", text: "#374151", dot: "#6b7280" },
                };
                const sp = statusPalette[status] || statusPalette.pending;
                const cu = props.selectedLeave?.company_user || {};
                const Tile = ({ label, value, icon }) => (
                  <div
                    className="col-md-3 col-6"
                    style={{ borderRight: "1px solid #f1f2f4" }}
                  >
                    <div style={{ padding: "4px 8px" }}>
                      <div
                        style={{
                          fontSize: 11,
                          fontWeight: 600,
                          letterSpacing: "0.06em",
                          textTransform: "uppercase",
                          color: "#9ca3af",
                          marginBottom: 6,
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        {icon}
                        {label}
                      </div>
                      <div
                        style={{
                          fontSize: 14.5,
                          fontWeight: 600,
                          color: "#111827",
                          lineHeight: 1.3,
                        }}
                      >
                        {value || <span style={{ color: "#9ca3af", fontWeight: 400 }}>—</span>}
                      </div>
                    </div>
                  </div>
                );
                return (
                  <div className="row mb-4">
                    <div className="col-12">
                      <div
                        className="card border-0 shadow-sm"
                        style={{ borderRadius: 14, overflow: "hidden", background: "#ffffff" }}
                      >
                        {/* Employee strip */}
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{
                            padding: "16px 20px",
                            background: "linear-gradient(135deg, #fff5f6 0%, #ffffff 100%)",
                            borderBottom: "1px solid #f5e8ea",
                          }}
                        >
                          <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
                            <div style={{ marginRight: 12, flexShrink: 0 }}>
                              <Image
                                src={cu.profile_image}
                                type="user"
                                style={{
                                  width: 44, height: 44, borderRadius: "50%",
                                  objectFit: "cover", border: "2px solid #ffffff",
                                  boxShadow: "0 0 0 1px #f1f2f4",
                                }}
                              />
                            </div>
                            <div style={{ minWidth: 0 }}>
                              <div
                                className="d-flex align-items-center"
                                style={{ gap: 8, fontSize: 15, fontWeight: 700, color: "#111827" }}
                              >
                                <span>
                                  {cu.first_name} {cu.last_name}
                                </span>
                                {props?.selectedLeave?.id && (
                                  <span
                                    onClick={(e) => { e.stopPropagation(); setStatisticsModal(true); }}
                                    style={{
                                      cursor: "pointer", color: "#d3001a",
                                      fontSize: 13, display: "inline-flex", alignItems: "center",
                                    }}
                                    title="View Statistics"
                                  >
                                    <FaChartLine />
                                  </span>
                                )}
                              </div>
                              <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>
                                {cu.emp_no ? cu.emp_no : ""}
                                {cu.emp_no && cu.position_name ? " · " : ""}
                                {cu.position_name || ""}
                              </div>
                            </div>
                          </div>
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 6,
                              padding: "5px 12px",
                              borderRadius: 999,
                              background: sp.bg,
                              color: sp.text,
                              fontSize: 12,
                              fontWeight: 700,
                              letterSpacing: "0.03em",
                              textTransform: "uppercase",
                              flexShrink: 0,
                              whiteSpace: "nowrap",
                            }}
                          >
                            <span
                              style={{
                                width: 8, height: 8, borderRadius: "50%",
                                background: sp.dot, display: "inline-block",
                              }}
                            />
                            {(props.selectedLeave?.approval_status || "—").replace(/_/g, " ")}
                          </span>
                        </div>

                        {/* Tiles */}
                        <div className="row g-0" style={{ padding: "16px 16px" }}>
                          <Tile
                            label="Leave Type"
                            value={props.selectedLeave?.leave_type?.description}
                            icon={<FaCalendarAlt style={{ fontSize: 10 }} />}
                          />
                          <Tile
                            label="From"
                            value={
                              props?.selectedLeave?.start_date
                                ? formatDateHandler2(props.selectedLeave.start_date)
                                : null
                            }
                            icon={<FaCalendarAlt style={{ fontSize: 10 }} />}
                          />
                          <Tile
                            label="To"
                            value={
                              props?.selectedLeave?.end_date
                                ? formatDateHandler2(props.selectedLeave.end_date)
                                : null
                            }
                            icon={<FaCalendarAlt style={{ fontSize: 10 }} />}
                          />
                          <div className="col-md-3 col-6">
                            <div style={{ padding: "4px 8px" }}>
                              <div
                                style={{
                                  fontSize: 11, fontWeight: 600, letterSpacing: "0.06em",
                                  textTransform: "uppercase", color: "#9ca3af", marginBottom: 6,
                                }}
                              >
                                Days
                              </div>
                              <div
                                style={{
                                  fontSize: 14.5, fontWeight: 600, color: "#111827",
                                  lineHeight: 1.3,
                                }}
                              >
                                {props.selectedLeave?.no_of_days || "—"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}

              {/* Statistics */}
              <div className="row mb-4">
                <div className="col-md-6">
                  <StatisticComponent />
                </div>
              </div>

              

                {/* Employee Comment */}
                <div className="row mb-4">
                  <div className="col-12">
                    <div
                      className="card border-0 shadow-sm"
                      style={{ borderRadius: 12, padding: 18, background: "#ffffff" }}
                    >
                      <div className="d-flex align-items-center mb-3">
                        <div
                          style={{
                            width: 32, height: 32, borderRadius: 10,
                            background: "#eff6ff", color: "#2563eb",
                            display: "inline-flex", alignItems: "center", justifyContent: "center",
                            marginRight: 10,
                          }}
                        >
                          <i className="la la-comment-dots" style={{ fontSize: 16 }} aria-hidden="true" />
                        </div>
                        <div style={{ fontWeight: 700, fontSize: 14, color: "#111827" }}>
                          Employee Comment
                        </div>
                      </div>
                      {props.selectedLeave?.comment ? (
                        <div
                          style={{
                            fontSize: 14,
                            lineHeight: 1.55,
                            color: "#1f2937",
                            padding: "12px 14px",
                            background: "#f9fafb",
                            borderLeft: "3px solid #d3001a",
                            borderRadius: "0 8px 8px 0",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {props.selectedLeave.comment}
                        </div>
                      ) : (
                        <div
                          style={{
                            fontSize: 13,
                            color: "#9ca3af",
                            fontStyle: "italic",
                            padding: "10px 0",
                          }}
                        >
                          No comment provided.
                        </div>
                      )}
                    </div>
                  </div>
                </div>


                {/* Leave Address */}
                {props.selectedLeave?.leave_address && (
                  <div className="row mb-4">
                    <div className="col-12">
                      <LeaveAddressSelected address={props.selectedLeave?.leave_address} />
                    </div>
                  </div>
                )}

                {/* Role Delegation */}
                {props.selectedLeave?.role_delegation && (
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className="card border-0 shadow-sm" style={{ borderRadius: "10px", padding: "16px" }}>
                        <label className="col-form-label mb-3" style={{ fontWeight: "600", fontSize: "14px", color: "#374151", marginBottom: "12px" }}>
                          Role Delegation
                        </label>
                        <div className="d-flex align-items-center">
                          <div className="avatar me-3">
                            <Image 
                              src={props.selectedLeave?.role_delegation?.profile_image} 
                              style={{ objectFit: "cover", width: "48px", height: "48px", borderRadius: "50%" }}  
                              type="user"
                            />
                          </div>
                          <div>
                            <div style={{ fontWeight: "500", fontSize: "14px", color: "#111827" }}>
                              {props.selectedLeave.role_delegation?.first_name} {props.selectedLeave?.role_delegation?.last_name}
                            </div>
                            {props.selectedLeave?.role_delegation?.emp_no && (
                              <span style={{ fontSize: "12px", color: "#6b7280" }}>
                                {props.selectedLeave?.role_delegation?.emp_no}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Decision Section — hidden when the only action is "Cancel"
                    (handled below by a dedicated Cancel Request card). */}
                {statusOptions.length > 0 && !(statusOptions.length === 1 && statusOptions[0].value === "cancelled") && (
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className="card border-0 shadow-sm" style={{ borderRadius: "12px", padding: "22px", background: "linear-gradient(135deg, #fff5f5 0%, #ffffff 100%)", border: "1px solid #fde2e6" }}>
                        <div className="d-flex align-items-center mb-3" style={{ gap: 12 }}>
                          <div
                            style={{
                              width: 36, height: 36, borderRadius: 10,
                              background: "#fee2e2", color: "#dc2626",
                              display: "inline-flex", alignItems: "center", justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            <i className="la la-gavel" style={{ fontSize: 18 }} aria-hidden="true" />
                          </div>
                          <div style={{ minWidth: 0 }}>
                            <div style={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>
                              {decisionCopy.heading}
                              <span className="text-danger" style={{ marginLeft: 4 }}>*</span>
                            </div>
                            {decisionCopy.sub && (
                              <div style={{ fontSize: 12.5, color: "#6b7280", marginTop: 2 }}>
                                {decisionCopy.sub}
                              </div>
                            )}
                          </div>
                        </div>
                        <Controller
                          name="approval_status"
                          control={statusControl}
                          render={({ field }) => (
                            <div className="d-flex flex-wrap gap-3">
                              {statusOptions.length > 0 && statusOptions.some(option => option.value === "approved" || option.value === "cancel_approved") && (
                                <>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      if(statusOptions.some(option => option.value === "cancel_approved")){
                                        field.onChange({ label: "Cancel Approved", value: "cancel_approved" })
                                      }else{
                                        field.onChange({ label: "Approved", value: "approved" })
                                      }
                                    }}
                                    disabled={statusOptions.length === 0}
                                    style={{
                                      padding: "12px 24px",
                                      borderRadius: "8px",
                                      border: field.value?.value === "approved" || field.value?.value === "cancel_approved" 
                                        ? "2px solid #10b981" 
                                        : "2px solid #e5e7eb",
                                      background: field.value?.value === "approved" || field.value?.value === "cancel_approved"
                                        ? "#10b981"
                                        : "#ffffff",
                                      color: field.value?.value === "approved" || field.value?.value === "cancel_approved"
                                        ? "#ffffff"
                                        : "#374151",
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      cursor: statusOptions.length === 0 ? "not-allowed" : "pointer",
                                      transition: "all 0.2s ease",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                    onMouseEnter={(e) => {
                                      if (statusOptions.length > 0 && (field.value?.value !== "approved" && field.value?.value !== "cancel_approved")) {
                                        e.currentTarget.style.borderColor = "#10b981";
                                        e.currentTarget.style.background = "#f0fdf4";
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (field.value?.value !== "approved" && field.value?.value !== "cancel_approved") {
                                        e.currentTarget.style.borderColor = "#e5e7eb";
                                        e.currentTarget.style.background = "#ffffff";
                                      }
                                    }}
                                  >
                                    <FaCheckCircle style={{ fontSize: "16px" }} />
                                    Accept {statusOptions.some(option => option.value === "cancel_approved") ? "Cancellation" : "Approval"}
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      if(statusOptions.some(option => option.value === "cancel_rejected")){
                                        field.onChange({ label: "Cancel Rejected", value: "cancel_rejected" })
                                      }else{
                                        field.onChange({ label: "Rejected", value: "rejected" })
                                      }
                                    }}
                                    disabled={statusOptions.length === 0}
                                    style={{
                                      padding: "12px 24px",
                                      borderRadius: "8px",
                                      border: field.value?.value === "rejected" || field.value?.value === "cancel_rejected"
                                        ? "2px solid #ef4444"
                                        : "2px solid #e5e7eb",
                                      background: field.value?.value === "rejected" || field.value?.value === "cancel_rejected"
                                        ? "#ef4444"
                                        : "#ffffff",
                                      color: field.value?.value === "rejected" || field.value?.value === "cancel_rejected"
                                        ? "#ffffff"
                                        : "#374151",
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      cursor: statusOptions.length === 0 ? "not-allowed" : "pointer",
                                      transition: "all 0.2s ease",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                    onMouseEnter={(e) => {
                                      if (statusOptions.length > 0 && (field.value?.value !== "rejected" && field.value?.value !== "cancel_rejected")) {
                                        e.currentTarget.style.borderColor = "#ef4444";
                                        e.currentTarget.style.background = "#fef2f2";
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (field.value?.value !== "rejected" && field.value?.value !== "cancel_rejected") {
                                        e.currentTarget.style.borderColor = "#e5e7eb";
                                        e.currentTarget.style.background = "#ffffff";
                                      }
                                    }}
                                  >
                                    <FaTimesCircle style={{ fontSize: "16px" }} />
                                    Reject {statusOptions.some(option => option.value === "cancel_rejected") ? "Cancellation" : "Approval"}
                                  </button>
                                </>
                              )}
                              {statusOptions.length > 0 && statusOptions.some(option => option.value === "cancelled") && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    if(field.value?.value === "cancelled"){
                                      field.onChange({ label: "", value: "" })
                                    }else{
                                      field.onChange({ label: "Cancelled", value: "cancelled" })
                                    }
                                  }}
                                  style={{
                                    padding: "12px 24px",
                                    borderRadius: "8px",
                                    border: field.value?.value === "cancelled"
                                      ? "2px solid #f59e0b"
                                      : "2px solid #e5e7eb",
                                    background: field.value?.value === "cancelled"
                                      ? "#f59e0b"
                                      : "#ffffff",
                                    color: field.value?.value === "cancelled"
                                      ? "#ffffff"
                                      : "#374151",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                  onMouseEnter={(e) => {
                                    if (field.value?.value !== "cancelled") {
                                      e.currentTarget.style.borderColor = "#f59e0b";
                                      e.currentTarget.style.background = "#fffbeb";
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (field.value?.value !== "cancelled") {
                                      e.currentTarget.style.borderColor = "#e5e7eb";
                                      e.currentTarget.style.background = "#ffffff";
                                    }
                                  }}
                                >
                                  <MdOutlineError style={{ fontSize: "16px" }} />
                                  Cancel
                                </button>
                              )}
                            </div>
                          )}
                        />
                        {statusError.approval_status && (
                          <small className="text-danger mt-2 d-block" style={{ fontSize: "12px", marginTop: "8px" }}>
                            {statusError.approval_status?.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                )}




                {/* Comment Section — hidden when the only action is "Cancel"
                    (the dedicated Cancel Request card below has its own
                    inline comment field). */}
                {statusOptions.length > 0 && !(statusOptions.length === 1 && statusOptions[0].value === "cancelled") && (
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className="card border-0 shadow-sm" style={{ borderRadius: "10px", padding: "16px" }}>
                        <label className="col-form-label mb-2" style={{ fontWeight: "600", fontSize: "13px", color: "#6b7280", marginBottom: "8px" }}>
                          Comment
                        </label>
                        <Controller
                          name="comment"
                          control={statusControl}
                          render={({ field }) => (
                            <textarea
                              disabled={statusOptions.length === 0}
                              rows={4}
                              className="form-control"
                              value={field?.value || ""}
                              onChange={field?.onChange}
                              placeholder="Add your comment here..."
                              style={{
                                fontSize: "14px",
                                padding: "12px",
                                border: "1px solid #e5e7eb",
                                borderRadius: "8px",
                                resize: "none",
                              }}
                            />
                          )}
                        />
                        {statusError.comment && (
                          <small className="text-danger mt-2 d-block" style={{ fontSize: "12px", marginTop: "8px" }}>
                            {statusError.comment?.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Attachments */}
                <div className="row mb-4">
                  <div className="col-12">
                    <div
                      className="card border-0 shadow-sm"
                      style={{ borderRadius: 12, padding: 18, background: "#ffffff" }}
                    >
                      <div className="d-flex align-items-center mb-3">
                        <div
                          style={{
                            width: 32, height: 32, borderRadius: 10,
                            background: "#f5f3ff", color: "#7c3aed",
                            display: "inline-flex", alignItems: "center", justifyContent: "center",
                            marginRight: 10,
                          }}
                        >
                          <i className="la la-paperclip" style={{ fontSize: 16 }} aria-hidden="true" />
                        </div>
                        <div style={{ fontWeight: 700, fontSize: 14, color: "#111827" }}>
                          Attachments
                          {props?.selectedLeave?.attachments?.length ? (
                            <span
                              style={{
                                marginLeft: 8,
                                fontSize: 11,
                                fontWeight: 600,
                                color: "#7c3aed",
                                background: "#f5f3ff",
                                padding: "2px 8px",
                                borderRadius: 999,
                              }}
                            >
                              {props.selectedLeave.attachments.length}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      {props?.selectedLeave?.attachments?.length ? (
                        <LeaveAttachment fields={props?.selectedLeave?.attachments} />
                      ) : (
                        <div
                          style={{
                            fontSize: 13,
                            color: "#9ca3af",
                            fontStyle: "italic",
                            padding: "10px 0",
                          }}
                        >
                          No attachments.
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                  {/* Cancel Leave - bottom-of-modal placement. Two-step inline confirm: Step 1 prompt, Step 2 reason + confirm submit. */}
                  {statusOptions.length === 1 && statusOptions[0].value === "cancelled" && (
                    <div className="row mb-4">
                      <div className="col-12">
                        {!confirmingCancel ? (
                          <div
                            className="card border-0 shadow-sm"
                            style={{
                              borderRadius: 12,
                              padding: 22,
                              background: "#ffffff",
                              border: "1px solid #f1f2f4",
                            }}
                          >
                            <div className="d-flex align-items-start" style={{ gap: 14 }}>
                              <div
                                style={{
                                  width: 40, height: 40, borderRadius: 10,
                                  background: "#fef3c7", color: "#b45309",
                                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                                  flexShrink: 0,
                                }}
                              >
                                <MdOutlineError style={{ fontSize: 22 }} />
                              </div>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontWeight: 700, fontSize: 15, color: "#111827", marginBottom: 4 }}>
                                  Need to cancel this leave?
                                </div>
                                <div style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.55 }}>
                                  Your manager will be notified to approve the cancellation.
                                </div>
                              </div>
                            </div>
                            <div className="d-flex justify-content-end mt-3">
                              <button
                                type="button"
                                onClick={() => setConfirmingCancel(true)}
                                style={{
                                  padding: "10px 22px",
                                  borderRadius: 8,
                                  background: "#dc2626",
                                  border: "none",
                                  color: "#ffffff",
                                  fontWeight: 700,
                                  fontSize: 14,
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 8,
                                  boxShadow: "0 1px 2px rgba(220, 38, 38, 0.25)",
                                }}
                              >
                                <i className="la la-ban" style={{ fontSize: 16 }} aria-hidden="true" />
                                Request Cancellation
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div
                            className="card border-0 shadow-sm"
                            style={{
                              borderRadius: 12,
                              padding: 22,
                              background: "linear-gradient(135deg, #fef2f2 0%, #ffffff 70%)",
                              border: "1px solid #fecaca",
                            }}
                          >
                            <div className="d-flex align-items-start" style={{ gap: 14, marginBottom: 14 }}>
                              <div
                                style={{
                                  width: 40, height: 40, borderRadius: 10,
                                  background: "#fee2e2", color: "#dc2626",
                                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                                  flexShrink: 0,
                                }}
                              >
                                <i className="la la-exclamation-triangle" style={{ fontSize: 22 }} aria-hidden="true" />
                              </div>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontWeight: 700, fontSize: 15, color: "#111827", marginBottom: 4 }}>
                                  Cancel this leave request?
                                </div>
                                <div style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.55 }}>
                                  A cancellation request will be sent to your manager for approval.
                                </div>
                              </div>
                            </div>

                            <label
                              className="d-block mb-2"
                              style={{ fontSize: 12.5, fontWeight: 600, color: "#374151" }}
                            >
                              Reason <span style={{ color: "#9ca3af", fontWeight: 400 }}>(optional)</span>
                            </label>
                            <Controller
                              name="comment"
                              control={statusControl}
                              render={({ field }) => (
                                <textarea
                                  rows={3}
                                  className="form-control"
                                  value={field?.value || ""}
                                  onChange={field?.onChange}
                                  placeholder="e.g. Plans changed, will reapply later…"
                                  style={{
                                    fontSize: 14,
                                    padding: "10px 12px",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: 8,
                                    resize: "vertical",
                                    background: "#ffffff",
                                  }}
                                />
                              )}
                            />
                            {statusError.comment && (
                              <small className="text-danger mt-2 d-block" style={{ fontSize: 12 }}>
                                {statusError.comment?.message}
                              </small>
                            )}

                            <div className="d-flex justify-content-end mt-3" style={{ gap: 8 }}>
                              <button
                                type="button"
                                onClick={() => setConfirmingCancel(false)}
                                disabled={loading}
                                style={{
                                  padding: "10px 18px",
                                  borderRadius: 8,
                                  border: "1px solid #d1d5db",
                                  background: "#ffffff",
                                  color: "#374151",
                                  fontWeight: 600,
                                  fontSize: 13,
                                  cursor: loading ? "not-allowed" : "pointer",
                                }}
                              >
                                Go Back
                              </button>
                              <Button
                                loading={loading}
                                disabled={loading || uploadLoading}
                                type="submit"
                                className="btn"
                                label="Confirm Cancellation"
                                icon="la la-check"
                                style={{
                                  padding: "10px 22px",
                                  borderRadius: 8,
                                  background: "#dc2626",
                                  borderColor: "#dc2626",
                                  color: "#ffffff",
                                  fontWeight: 700,
                                  fontSize: 14,
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                {/* Submit Button — only for the approver flow (Accept/Reject).
                    The cancel-only flow has its own inline submit inside the
                    Cancel Leave Request card. If there are no available status
                    options at all (e.g. already-actioned leave), nothing to
                    submit, so the button is hidden. */}
                {statusOptions.length > 0 && !(statusOptions.length === 1 && statusOptions[0].value === "cancelled") && (
                  <div className="submit-section d-flex justify-content-end" style={{ paddingTop: "16px", borderTop: "1px solid #e5e7eb" }}>
                    <Button
                      loading={loading}
                      disabled={loading || uploadLoading}
                      className="btn btn-primary submit-btn"
                      type="submit"
                      label="Submit"
                      style={{
                        padding: "10px 32px",
                        borderRadius: "8px",
                        fontWeight: "600",
                        fontSize: "14px",
                        backgroundColor: "#d3001a",
                        borderColor: "#d3001a",
                      }}
                    />
                  </div>
                )}
              </form>
              ) : (
              <form  onSubmit={handleSubmit(onSubmit)}>

                <div className="row" >
              <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label d-flex">
                    User <span className="text-danger ">*</span>

                    {company_user && (
                      <div onClick={() => {
                        setStatisticsModal(true);
                      }} style={{cursor: "pointer"}}>
                      <FaChartLine
                        
                        className=" fa fa-bar-chart ms-3 cursor-pointer"  
                        // icon={"fa fa-bar-chart "} 

                        // type="submit"
                        // label="Statistics"
                      />
                      <span className="ms-1">Statistics</span>
                      </div>

                    )}

                  </label>
                 
                  <Controller
                        name={`company_user`}
                        // name={"assignee"}
                        control={control}
                        // defaultValue=""
                        // rules={{ required: 'Select a contact' }}
                        render={({ field }) => (
                          <>
                            <FilterSelect 
                            // className={"w-50"}
                            isDisabled={userOption.length == 1}
                            isClearable={true} 
                            onChange={(e) => {
                              field.onChange(e);
                              setValue("leave_address",)
                            }}
                            optionLabel={"label"} 
                            optionValue={'value'} 
                            options={userOption}
                            defaultValue={userOption[0]}
                            value={field.value}
                              placeholder={"Select user"}
                              styles={customStyleSelect}
                              isLoading={userDataLoading}
                              />

                           
                          </>
                        )}
                      />
                      {errors.company_user && (
                        <small className="text-danger">
                          {errors.company_user?.message}
                        </small>
                      )}

                </div>
                </div>

                <div className="row" >
                  <div className="col-md-6">
                    <StatisticComponent />
                  </div>
                </div>

                  <div className="row" >
                <div className="input-block mb-3 col-md-6 col-cm-12">
                  <label className="col-form-label">
                    Requested On 
                  </label>
                  <Controller
                    name="requested_on"
                    control={control}         
                    
                    render={({ field }) => (
                      <DateInput
                              className="form-control floating datetimepicker "
                              selected={new Date()}
                              disabled 
                              dateFormat="dd-MM-yyyy"
                            />
                    
                    )}
                  />
                  

                </div>


                <div className="input-block mb-3  col-md-6 col-cm-12">
                  <label className="col-form-label">
                    Leave Type <span className="text-danger">*</span>
                  </label>
                  <Controller
                        name={`leave_type`}
                        // name={"assignee"}
                        control={control}
                        // defaultValue=""
                        // rules={{ required: 'Select a contact' }}
                        render={({ field }) => (
                          <>
                            <FilterSelect 
                            isClearable={true} 
                            onChange={(e) => {
                              field.onChange(e);
                            }}
                            optionLabel={"label"} 
                            optionValue={'value'} 
                            options={filteredLeaveType}
                            value={field.value}
                              placeholder={"Leave Type"}
                              styles={customStyleSelect}
                              isLoading={false}
                              />

                           
                          </>
                        )}
                      />
                      {errors.leave_type && (
                        <small className="text-danger">
                          {errors.leave_type?.message}
                        </small>
                      )}

                </div>
                </div>

             

              <div className="row" >
                <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    From <span className="text-danger">*</span>
                  </label>
                  {/* <div className="cal-icon"> */}
                  <Controller
                          name="start_date"
                          control={control}
                          // rules={{ required: 'File name is required' }}
                          render={({ field }) => (
                            <DateInput
                                    className="form-control floating datetimepicker "
                                    selected={field?.value}
                                  onChange={(e) => {
                                    const value = e?.target?.value;
                                    // If "From" moves past "To", clamp "To" to the same day
                                    if (end && value && value > end) {
                                      setValue("end_date", value, { shouldValidate: true, shouldDirty: true });
                                    }
                                    field.onChange(value);
                                        // Recalculate number of days on start date change
                                        // setNumberOfDays(calculateDays(date, endDate));
                                      }}
                                    dateFormat="dd-MM-yyyy"
                                    minDate={ user?.role?.access_scope === "store_manager" || user?.role?.access_scope === "all" ? "": new Date(new Date().getFullYear(), new Date().getMonth() - 1, 19)}
                                  
                                  />
                          
                          )}
                        />

                  {errors.start_date && (
                        <small className="text-danger">
                          {errors.start_date?.message}
                        </small>
                      )}
                   
                  {/* </div> */}
                </div>
                <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    To <span className="text-danger">*</span>
                  </label>
                  {/* <div className="cal-icon"> */}
                  <Controller
                          name="end_date"
                          control={control}
                          // rules={{ required: 'File name is required' }}
                          render={({ field }) => (
                            <DateInput
                                    className="form-control floating datetimepicker "
                                    selected={field?.value}
                                    onChange={(e) => {
                                      const value = e?.target?.value;
                                      // If user picks a "To" before "From", move "From" back to match "To"
                                      if (start && value && value < start) {
                                        setValue("start_date", value, { shouldValidate: true, shouldDirty: true });
                                      }
                                      field.onChange(value);
                                      // Recalculate number of days on end date change
                                      // setNumberOfDays(calculateDays(startDate, date));
                                    }}
                                    dateFormat="dd-MM-yyyy"
                                    minDate={startDateObj || undefined} 
                                  />
                          
                          )}
                        />
                        {errors.end_date && (
                        <small className="text-danger">
                          {errors.end_date?.message}
                        </small>
                      )}
                  {/* </div> */}
                </div>
                </div>
                <div className="row" >
                <div className="input-block mb-3  col-md-6 col-sm-12">
                    <label className="col-form-label">
                      Number of Days 
                    </label>
                    <div className="input-group">
                    <input className="form-control" id="numberOfDays" readOnly type="text" value={numberOfDays} />
                    {loadingLeaveBalance ?
                      <label className="input-group-text" htmlFor="numberOfDays">
                        <i className="fas fa-spinner fa-spin" ></i> 
                        </label>
                        : ""}

                        
                        </div>  
                        {
                          leaveBalanceSummary?.bc_data?.Accrual &&
                          <small  >
                            No of days Accrued as of {formatDateHandler2(format(new Date(), "yyyy-MM-dd"))}: 
                            <strong>{leaveBalanceSummary?.bc_data?.Accrual} Days</strong>
                          </small>
                        } 
                        {
                          leaveBalanceSummary?.max_allowed_days  !== "N/A"  && (leaveBalance+numberOfDays) > leaveBalanceSummary?.max_allowed_days &&
                          <>
                          <br/>
                          <small className="bg-danger text-white p-2 rounded mt-4" >
                            <span>You are exceeding the maximum allowed days for {leaveType?.label}.</span>
                          </small>
                          
                          </>
                        } 
                  </div>              

               
                <div className="input-block mb-3  col-md-6 col-sm-12">
                  <label className="col-form-label">
                    Remaining Leaves 
                  </label>
                  <div className="input-group">
                  <input
                    className="form-control"
                    readOnly
                    defaultValue={leaveBalance}
                    value={leaveBalance}
                    type="text"
                    id="leaveBalance"
                  />
                  {loadingLeaveBalance ?
                      <label className="input-group-text" htmlFor="leaveBalance">
                        <i className="fas fa-spinner fa-spin" ></i> 
                        </label>
                        : ""}
                        </div>
                </div>
                </div>
                <div className="row" >
                <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    Leave Reason <span className="text-danger">*</span>
                  </label>
                  <Controller
                          name="comment"
                          control={control}
                          // rules={{ required: 'File name is required' }}
                          render={({ field }) => (
                            <textarea
                            rows={4}
                            className="form-control"
                            value={field?.value}
                            onChange={field?.onChange}
                          />
                          
                          )}
                        />
                  {errors.comment && (
                        <small className="text-danger">
                          {errors.comment?.message}
                        </small>
                      )}
                </div>

                </div>

                <div className="row" >

                <div className="input-block mb-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <label className="d-block col-form-label">
                    Role delegation
                  </label>
                  <div className="status-toggle ms-4">
                    <input
                      onChange={e=> setDelegationEnabled(e.target.checked)}
                      value={roleDelegationEnabled}
                      type="checkbox"
                      id="unit_calculation"
                      className="check"
                    />
                    <label htmlFor="unit_calculation" className="checktoggle">
                      checkbox
                    </label>
                  </div>
                </div>
                </div>


                {
                  roleDelegationEnabled &&
                  <div className="row" >
              <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    Role Delegation  
                  </label>
                  <Controller
                        name={`role_delegation`}
                        // name={"assignee"}
                        control={control}
                        // defaultValue=""
                        // rules={{ required: 'Select a contact' }}
                        render={({ field }) => (
                          <>
                            <FilterSelect 
                            // className={"w-50"}
                            // disabled={userOption.length == 1}
                            isClearable={true} 
                            onChange={(e) => {
                              field.onChange(e);
                            }}
                            optionLabel={"label"} 
                            optionValue={'value'} 
                            options={roleDelegationOptions}
                            value={field.value}
                              placeholder={"Select user"}
                              styles={customStyleSelect}
                              isLoading={roleDelegationLoading}
                              />

                           
                          </>
                        )}
                      />
                    

                </div>
                </div>
                }


<div className="row">
<div className="input-block mb-3  col-md-6 col-cm-12">
                  <label className="col-form-label">
                    Leave Address 
                    
                    {
                      company_user?.value === user?.id &&
                      <span className="text-danger">*</span>
                    }
                    
                  </label>
                  <div className="d-flex align-items-center gap-2" >
                    <div className="flex-grow-1" style={{ display: "flex", alignItems: "center" }}>
                    <Controller
                        name={`leave_address`}
                        // name={"assignee"}
                        control={control}
                        // defaultValue=""
                        // rules={{ required: 'Select a contact' }}
                        render={({ field }) => (
                          <div style={{ width: "100%" }}>
                            <FilterSelect 
                            isClearable={true} 
                            onChange={(e) => {
                              field.onChange(e);
                            }}
                            optionLabel={"label"} 
                            getOptionLabel={(e) => `${e.name} ${e.address_1} ${e.address_2} ${e.city}`} // Label for dropdown

                            optionValue={'value'} 
                            options={leaveAddress}
                            value={field.value}
                              placeholder={"Leave Address"}
                              styles={customStyleSelect}
                              isLoading={leaveAddressLoading}
                              noOptionsLabel="addresses"
                              />
                          </div>
                        )}
                      />
                    </div>
                    
                    <div className="d-flex align-items-center gap-2">
                     
                    <Link
                      to="#"
                      disabled={leaveAddressLoading}
                      className="edit-icon"
                      onClick={fetchAddressList}
                    >
                      <i className={ leaveAddressLoading ? "fas fa-spin fa-spinner": "fa fa-refresh"} />
                    </Link>
                    {
                      user.id == company_user?.value &&
                      <Link
                    target={"_blank"}
                      to={`/employees/${company_user?.value}`}
                      className="edit-icon"
                    >
                      <i className="fa fa-plus" />
                    </Link>
                    }
                    
                    </div>
                  </div>
                  {errors.leave_address && (
                    <small className="text-danger">
                      {errors.leave_address?.message}
                    </small>
                  )}
                  
                  {
                          leave_address && 
                          <LeaveAddressSelected address={leave_address} />
                      }
                  
                </div>
</div>


                <div className="row">
                  <div className="col-md-6 col-sm-12">
                  <div className="input-block mb-3">

                  <label className="col-form-label">Attachments {
                    uploadLoading && <i class="fa fa-spinner fa-spin" ></i>
                  }</label>

                  <div
                      {...getRootProps({ className: 'dropzone' })}
                      style={{
                        border: '2px dashed #000',
                        padding: '20px',
                        textAlign: 'center',
                      }}
                    >
                      <input {...getInputProps()} />
                      <p>Drag & Drop your files here, or click to select files</p>
                    </div>

               



                  {/* <input
                    type="file"
                    className="form-control"
                    id="cv_upload"
                    // accept=".png, .jpg, .jpeg"
                    onChange={fileUploadHandler}
                    disabled={uploadLoading}
                    multiple
                  /> */}
                  <p className="text-danger mb-2">
                    {errors?.attachments?.message}
                  </p>
                  
                </div>




                  </div>

                  
                </div>
                
                <div className="col-12" >
                <Attachment fields={fields} remove={remove}  />

                </div>

                

                <div className="submit-section">
                <Button
                  loading={loading}
                  disabled={loading || uploadLoading}
                    className="btn btn-primary submit-btn"             
                    type="submit"
                    label="Submit"
                  />
                </div>
              </form>
              )}
              
            </div>
          </div>
    </EssFullWidthModal>

    {/* <EssFullWidthModal
      mask={false}
      title={`Leave Statistics: ${ props.selectedLeave ? props.selectedLeave?.company_user?.first_name + " " + props.selectedLeave?.company_user?.last_name :  company_user?.label } `}
      open={statisticsModal}
      width={"70%"}
      footer={[]}
      onCancel={() => setStatisticsModal(false)}
      className="full-width-modal"
    >
      <div className="modal-content">
        <div className="modal-body">
          <div className="row">
            <div className="col-md-12">
              
              {statisticsLoading ? (
                <div className="text-center py-5">
                  <i className="fas fa-spinner fa-spin fa-2x"></i>
                  <p className="mt-2">Loading statistics...</p>
                </div>
              ) : statisticsData ? (
                <div className="chart-container" style={{ position: 'relative', height: '400px' }}>
                  <Bar
                    data={statisticsData?.graph_data}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      plugins: {
                        legend: {
                          position: 'top',
                        },
                        title: {
                          display: true,
                          text: 'Leave Statistics Overview',
                        },
                        tooltip: {
                          callbacks: {
                            label: function(context) {
                              let label = context.dataset.label || '';
                              if (label) {
                                label += ': ';
                              }
                              if (context.parsed.y !== null) {
                                // Only display if value is not 0
                                if (context.parsed.y !== 0) {
                                  label += context.parsed.y;
                                } else {
                                  label += 'No data';
                                }
                              }
                              return label;
                            }
                          }
                        }
                      },
                      scales: {
                        y: {
                          beginAtZero: true,
                          title: {
                            display: true,
                            text: 'Number of Days'
                          }
                        },
                        x: {
                          title: {
                            display: true,
                            text: 'Year'
                          }
                        }
                      },
                      // Hide data labels for zero values
                      plugins: {
                        datalabels: {
                          color: '#fff', 
                          formatter: (value) => {
                            // Don't show labels for zero values
                            return value > 0 ? value : '';
                          }
                        }
                      }
                    }}
                  />
                </div>
              ) : (
                <div className="alert alert-info">
                  No statistics data available for {props.selectedLeave?.company_user?.first_name} {props.selectedLeave?.company_user?.last_name}.
                </div>
              )}
              
              
            </div>
          </div>
        </div>
      </div>
    </EssFullWidthModal> */}

    </>
  );
};

export default EmployeeLeaveModelPopup;
